import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table } from 'components/table/table';
import styled from 'styled-components';
import spacing from 'theme/spacing';
const TableWrapper = styled.div `
  margin-top: 20px;
`;
const StyledTitle = styled.span `
  font-size: 20px;
  padding-left: ${spacing.spacing12};
  font-style: normal;
  font-weight: 400;
`;
export const HealthCheckTabContent = ({ categoryValues }) => {
    return categoryValues.map(categoyValue => {
        // Table columns are based on the element with the longest list of values(propertyValues)
        const columnValueTypes = categoyValue.subcategoryValues
            .reduce((a, b) => (a.propertyValues.length > b.propertyValues.length ? a : b))
            .propertyValues.map(value => value.type);
        // Construct table columns. Based on the category tag as the first column and values from all tags above
        const columns = [...columnValueTypes];
        columns.unshift(categoyValue.description);
        return (_jsxs(TableWrapper, { children: [categoyValue.name && _jsx(StyledTitle, { children: categoyValue.name }), _jsx(Table, { columns: columns, rows: categoyValue.subcategoryValues, columnValueTypes: columnValueTypes })] }, categoyValue.name));
    });
};
